<template>
  <div class="early-warning">
    <div class="left">
      <div class="monitor-title">
        <i class="iconfont icon-a-shexiangtou_huaban1"></i>
        <span>监控画面</span>
      </div>
      <video-container v-if="warningInfo.device !== null && warningInfo.device.deviceSerial" :foot="false" :info="warningInfo.device" :token="warningInfo.device.token"></video-container>
      <video-da-hua v-if="warningInfo.device !== null && warningInfo.device.deviceId" :info="warningInfo.device" :show-foot="false"></video-da-hua>
      <div class="device-info">
        <div class="list">
          <div class="label">设备名称</div>
          <div class="text">{{ warningInfo.device !== null ? warningInfo.device.deviceName : '-' }}</div>
        </div>
        <div class="list">
          <div class="label">设备地点</div>
          <div class="text">{{ warningInfo.device !== null ? warningInfo.device.deviceLocation : '-' }}</div>
        </div>
        <div class="list">
          <div class="label nbsp">管理员</div>
          <div class="text">{{  warningInfo.adminName }}</div>
        </div>
        <div class="list">
          <div class="label">
            <div class="nbsp">管理员</div>
            <div>电话号码</div>
          </div>
          <div class="text">{{ warningInfo.adminPhone }}</div>
        </div>
        <div class="list">
          <div class="label">网格员</div>
          <div class="text">{{ warningInfo.gridName }}</div>
        </div>
        <div class="list">
          <div class="label">
            <div class="nbsp">网格员</div>
            <div>电话号码</div>
          </div>
          <div class="text">{{ warningInfo.gridPhone }}</div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="scroll-y" ref="right-scroll">
        <LineItem0 v-if="warningInfo.status >= 0" class="line-item" :info="warningInfo"></LineItem0>
        <LineItem1 v-if="warningInfo.status >= 0" class="line-item" :info="warningInfo" :admin-id="adminInfo.user_id" @handleScene="handleScene" @relieve="relieve"></LineItem1>
        <LineItem3 v-if="warningInfo.status >= 2 && warningInfo.status !== 5" class="line-item" :info="warningInfo" @refreshInfo="refreshInfo"></LineItem3>
        <LineItem4 v-if="warningInfo.status >= 3 && warningInfo.status !== 5" class="line-item" :info="warningInfo"></LineItem4>
        <LineItem5 v-if="warningInfo.status >= 3 && warningInfo.status !== 5" :info="warningInfo" @refreshInfo="refreshInfo"></LineItem5>
        <LineItem6 v-if="warningInfo.status === 5" class="line-item" :info="warningInfo"></LineItem6>
      </div>
    </div>
    <BabyDialog v-show="showConfirm" tip="您确定要现场处理/解除预警吗?" @close="showConfirm = false" @confirm="handleConfirm">
      <div v-if="confirmType === 1" class="reason-box">
        <el-radio-group v-model="relieveReason" class="form-radio-group">
          <el-radio label="各类反光">各类反光</el-radio>
          <el-radio label="各类烟筒">各类烟筒</el-radio>
          <el-radio label="太阳或者车灯">太阳或者车灯</el-radio>
          <el-radio label="无法辨别">无法辨别</el-radio>
          <el-radio label="非火光等热源">非火光等热源</el-radio>
          <el-radio label="真火延时处理">真火延时处理</el-radio>
          <el-radio label="其他">其他</el-radio>
        </el-radio-group></div>
    </BabyDialog>
  </div>
</template>

<script>
import videoContainer from "../../../home/components/videoContainer";
import LineItem0 from "./LineItem1";
import LineItem1 from "./LineItem2";
import LineItem3 from "./LineItem3";
import LineItem4 from "./LineItem4";
import LineItem5 from "./LineItem5";
import LineItem6 from "./LineItem6";
import {warningDetail} from "@/api/warning";
import videoDaHua from "../../../home/components/videoDaHua";
import BabyDialog from "../../../../components/Dialog/Confirm";
import { warningProcess } from "@/api/warning";
export default {
  name: "earlyWarning", // 预警办理
  components: { videoContainer, LineItem0, LineItem1, LineItem4, LineItem3, LineItem5, videoDaHua, LineItem6, BabyDialog },
  props: {
    info: { type: Object, default: () => {} }
  },
  data () {
    return {
      showConfirm: false,
      confirmType: 0, // 0为现场处理， 1为预警解除
      warningInfo: {

      },
      relieveReason: '各类反光',
      adminInfo: {

      }
    }
  },
  mounted() {
    this.adminInfo = this.$store.state.user.userInfo
    this.warningInfo = this.info
    this.refreshInfo()
    this.$nextTick(() => {
      this.$refs["right-scroll"].style.display = 'none'
      setTimeout(() => {
        this.$refs["right-scroll"].style.display = 'block'
      }, 300)
    })
  },
  methods: {
    refreshInfo () {
      warningDetail({ id: this.warningInfo.id }).then(res => {
        for (let prop in res.data) {
          this.warningInfo[prop] = res.data[prop]
        }
      })
    },
    handleScene () {
      this.confirmType = 0
      return this.showConfirm = true
    },
    relieve () {
      this.confirmType = 1
      return this.showConfirm = true
    },
    handleConfirm () {
      this.showConfirm = false
      if (this.confirmType === 0) {
        this.confirmScene()
      } else {
        this.confirmRelieve()
      }
    },
    confirmScene () {
      const form = {
        id: this.warningInfo.id,
        adminId: this.warningInfo.adminId || this.adminInfo.user_id,
        status: 1
      }
      warningProcess(form).then(() => {
        this.refreshInfo()
        this.$bus.emit('refreshWarning') // 刷新列表
        this.$message.success('已提交现场处理')
      })
    },
    confirmRelieve () {
      const form = {
        id: this.warningInfo.id,
        adminId: this.warningInfo.adminId || this.adminInfo.user_id,
        relieveReason: this.relieveReason,
        status: 5
      }
      warningProcess(form).then(() => {
        this.refreshInfo()
        this.$bus.emit('refreshWarning') // 刷新列表
        this.$message.success('已解除预警')
      })
    }
  }
}
</script>

<style scoped lang="less">
  .early-warning{
    height: 740px;
    display: grid;
    grid-template-columns: 550px 1fr;
    position: relative;
    .left{
      padding-right: 10px;
      .monitor-title{
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #00FFF6;
        i{
          margin-right: 10px;
          font-size: 28px;
        }
      }
      .device-info{
        display: grid;
        grid-template-columns: 1fr 1fr;
        font-size: 18px;
        .list{
          padding-left: 10px;
          display: grid;
          grid-template-columns: 80px 1fr;
          //height: 40px;
          padding-top: 20px;
          //padding-bottom: 20px;
          .label{
            color: #00B2FF;
          }
          .nbsp{
            letter-spacing: 8px;
          }
          .text{
            margin-left: 20px;
          }
        }
      }
    }
    .right{
      border-left: 1px solid #00FFF6;
      height: 750px;
      .scroll-y{
        height: calc(100% - 20px);
      }
    }
  }
  .reason-box{
    padding: 0 50px 20px 50px;
  }
</style>
